import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getAppointmentsQueryName } from "./get-appointments";
import assignDoctor from "../../controllers/appointments/assign-doctor";

const useAssignDoctorToApt = () => {
  const queryClient = useQueryClient();

  return useMutation(assignDoctor, {
    onSuccess: () =>
      Promise.all([queryClient.invalidateQueries(getAppointmentsQueryName())]),
  });
};

export default useAssignDoctorToApt;
